// extracted by mini-css-extract-plugin
module.exports = {"container":"container--2_z0g","recommendations":"recommendations--1WJWj","video":"video--PQHF4"};